import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Partner } from 'types';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import { getPartnersFromOldOperation } from '../../utils/getPartnersFromOldOperation';
import SplitOperationTableRow from './SplitOperationTableRow';

const SplitOperationTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const partners = data.isOldOperation
    ? getPartnersFromOldOperation(data.operation)
    : data.partners;

  const hasData = partners?.length > 0;

  return (
    <>
      {hasData ? (
        <tbody>
          {partners?.map((partner: Partner, index: number) => (
            <tr
              className="nk-tb-item"
              // eslint-disable-next-line react/no-array-index-key
              key={`split-data-row-${index}`}
            >
              <SplitOperationTableRow index={index} partner={partner} />
            </tr>
          ))}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('NoDataFound')}
          infoMessage=""
          colspan={7}
        />
      )}
    </>
  );
};

export default SplitOperationTableBody;
